// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { IsoCurrencyCode } from '@/currency/constants/iso';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { DateTime } from 'luxon';

/**
 * Fetches one cost currency's slice of an (unpaged, large) snapshot report. Each
 * report covers a single currency; the picker's options come from the org-wide
 * asset-currency list, so this only refetches when the active currency or the
 * as-of date changes.
 */
export function useSnapshotCurrencyQuery<T>(
  queryKeyBase: string,
  asOfDate: DateTime,
  enabled: boolean,
  activeCurrencyCode: IsoCurrencyCode,
  fetchFn: (args: {
    asOfDate: DateTime;
    currency: IsoCurrencyCode;
  }) => Promise<T>
): UseQueryResult<T> {
  return useQuery({
    queryKey: [queryKeyBase, asOfDate.toISODate(), activeCurrencyCode],
    queryFn: () => fetchFn({ asOfDate, currency: activeCurrencyCode }),
    enabled,
  });
}
